import styled from 'styled-components';

export const Wrap = styled.div`
  position:relative;
  background:url(${require('../../assets/img/2_21.png').default})center;
  background-size:cover;
  /* height:calc(100% - 1.06rem); */
  padding:.74rem;
  padding-bottom:0;
  section{
    width:6.02rem;
    height:10.66rem;
    background-color:#fff;
    padding:0.54rem .57rem;
    overflow-y:scroll;

    .btn{
      width:100%;
      text-align:center;
      margin-top:.8rem !important;
      button{
        background-color:#8fc31f;
        color: #fff;
        width:2.38rem;
        height:.6rem;
        line-height:.2rem;
        span{
          font-size:.3rem;
        }
        
      }
      
    }
  }`